import useStyles from "isomorphic-style-loader/useStyles";
import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { useSelector, useStore } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import Header from "../../../../components/header";
import { SearchBar } from "../../components/search-bar";
import classes from './style.module.scss';
import { useState } from "react";
import { useRef } from "react";
import { Iconfont } from "../../../../components/icon/iconfont";
import { action_fetch_ticket_questions_tree } from "../../../../../store/actions/pages/customer";
import { useApp } from "../../../../hooks/common";

const SearchResult = props => {
    useStyles(classes)
    const {intl, resultList, searchValue} = props
    return (
        <div className={classes.ResultBox}>
            <div className={classes.ResultTitle}>{intl.formatMessage({id:'search_results'})}</div>
            {
                searchValue &&
                <div className={classes.ResultNum}>
                    {resultList.length}
                    &nbsp;
                    <span dangerouslySetInnerHTML={{__html: intl.formatMessage({id:"result_for"}, {search: `<strong>${searchValue}</strong>`})}}></span>
                </div>
            }
        </div>
    )
}

const SearchResultList = props => {
    useStyles(classes)
    const {intl, resultList, showDetail, highLightSearch, removeHeader} = props
    return (
        <div className={classes.ResultListBox}>
            {
                resultList.map((item, index) => {
                    return <div className={classes.ResultItemBox} onClick={()=> showDetail(item)} key={index}>
                            <div className={classes.ResultItemTitle}>
                                <span dangerouslySetInnerHTML={{__html: highLightSearch(item?.question)}}></span>
                                {/* <Iconfont style={{fontWeight:'500'}}>&#xe7af;</Iconfont>
                                <span>{item.likes ? item.likes : 0}</span> */}
                            </div>
                            <div className={classes.ResultItemContent} dangerouslySetInnerHTML={{__html: removeHeader(item.answer)}}></div>
                    </div>
                })
            }
        </div>
    )
}

const SearchNoResult = props => {
    useStyles(classes)
    const {intl, toContact} = props
    return (
        <div className={classes.NoResult}>
            <Iconfont className={classes.NoResultImg}>&#xe7c6;</Iconfont>
            <div className={classes.NoResultTxt}>
                {intl.formatMessage({id:"question"})}
                <span onClick={()=>toContact()}>{intl.formatMessage({id: 'contact_us'})}</span>
            </div>
        </div>
    )
}

const QuestionDetail = props => {
    useStyles(classes)
    const {intl, toContact, removeHeader, likeQuestion, setLikeQuestion, secondary, richText} = props
    return (
        <div className={classes.QuestionDetailBox}>
            <div className={classes.QuestionDetail}>
                <div className={classes.QuestionDetailTitle}>{secondary?.question}</div>
                <div className={classes.QuestionDetailContent} dangerouslySetInnerHTML={{__html:removeHeader(richText)}}></div>
            </div>
            <div className={classes.QuestionRateBox}>
                {/* <div className={classes.QuestionRateTxt}>{intl.formatMessage({id:"article_helpful"})}</div>
                <div className={classes.QuestionRateIcon}>
                    <Iconfont className={classes.Liked} style={{color:likeQuestion==1?'#57b936':''}} onClick={()=>setLikeQuestion(1)}>&#xe7af;</Iconfont>
                    <Iconfont className={classes.Unliked} style={{color:likeQuestion==2?'#e64545':'', transform: 'rotate(180deg)'}} onClick={()=>setLikeQuestion(2)}>&#xe7af;</Iconfont>
                </div> */}
                <div className={classes.NoResultTxt}>
                    {intl.formatMessage({id:"question"})}
                    <span onClick={()=>toContact()}>{intl.formatMessage({id: 'contact_us'})}</span>
                </div>
            </div>
        </div>
    )
}

const RelatedBox = props => {
    useStyles(classes)
    const {intl, parent, secondary, clickItem} = props
    return (
        <div className={classes.RelatedBox}>
            <div className={classes.RelatedTitle}>{intl.formatMessage({id:"related"})}</div>
            {
                parent?.children?.map((item,index)=>{
                    if(item.id != secondary.id){
                        return <div className={classes.RelatedItem} key={index} onClick={()=>clickItem(item)}>
                            {item.question}
                        </div>
                    }
                })
            }
        </div>
    )
}

const FaqSearch = props => {
    useStyles(classes)
    const Intl = useIntl()
    const location = useLocation()
    const history = useHistory()
    const [defaultShow, setDefaultShow] = useState(false)
    const [searchShow, setSearchShow] = useState(false)
    const [detailShow, setDetailShow] = useState(false)
    const [searchValue, setSearchValue] = useState('')
    const [resultList, setResultList] = useState([])
    const [isSearched, setIsSearched] = useState(false)
    const [questionDetail, setQuestionDetail] = useState(`<div style="color:red;">hdsjkadhladd;asd</div>`)
    const [likeQuestion, setLikeQuestion] = useState("")
    const [secondaryId, setSecondaryId] = useState(0)
    const [secondary, setSecondary] = useState({})
    const [richText, setRichText] = useState('')
    const [parent, setParent] = useState({})
    const [stopSearch, setStopSearch] = useState(false)
    const [initTime, setInitTime] = useState(0)
    const headerRef = useRef()
    const lastSearchId = useRef()
    const { customer, ticketQuestionsTree } = useSelector(state => state.pageCustomer);
    const store = useStore()
    const isApp = useApp()

    useEffect(async () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
        // document.body.style.background = "#fff"
        if (window.__INITIAL_STATE__) {
			// Allow the passed state to be garbage-collected
			delete window.__INITIAL_STATE__
		} else {

		}
        if(!ticketQuestionsTree){
            await FaqSearch.fetchData(store, null, null)
        }
        // initPage()
        return (() => {
            // document.body.style.background = ''
        })
    }, [])

    useEffect(() => {
        if(ticketQuestionsTree){
            initPage()
        }
    }, [history, location, ticketQuestionsTree])

    const initPage = () => {
        let search = history?.location?.state?.search || location?.search || 0
        let id = history?.location?.state?.id || location?.params?.id || 0
        let parentId = history?.location?.state?.parentId || location?.params?.parentId || 0
        let fromFAQ = history?.location?.state?.fromFAQ
        if((id && lastSearchId.current != id) || (fromFAQ && initTime == 0)){
            setInitTime(1)
            lastSearchId.current = id
            changeShow(search, id, parentId)
        }
    }

    const changeShow = (search, id, parentId) => {
        let type = search && id ? 0: search ? 1: id ? 2:'';
        switch(type){
            case 0:
                // 搜索框下拉列表点击
                show1(search, id, parentId)
                return;
            case 1:
                // 搜索框输入查询
                show2(search)
                return;
            case 2:
                // 点击到详情
                show3(id, parentId)
                return;
            default:
                return;
        }
    }

    const show1 = (search, id, parentId) => {
        let questionObj = ticketQuestionsTree?.find(tQuestion => tQuestion?.id == parentId)
        let secondaryObj = questionObj?.children?.find(tQuestionChild => tQuestionChild?.id == id)
        setDetailShow(true)
        setSearchShow(false)
        setSecondaryId(id)
        setSecondary(secondaryObj)
        setRichText(secondaryObj?.answer)
        setParent(questionObj)
        setSearchValue(search)
        setStopSearch(true)
    }

    const show2 = (search) => {
        setDetailShow(false)
        setSearchShow(true)
        setSearchValue(search)
        setStopSearch(false)
    }

    const show3 = (id, parentId) => {
        let questionObj = ticketQuestionsTree?.find(tQuestion => tQuestion?.id == parentId)
        let secondaryObj = questionObj?.children?.find(tQuestionChild => tQuestionChild?.id == id)
        setDetailShow(true)
        setSearchShow(false)
        setSecondaryId(id)
        setSecondary(secondaryObj)
        setRichText(secondaryObj?.answer)
        setParent(questionObj)
        setStopSearch(false)
        setSearchValue('')
    }

    const search = (e) => {
        let searchAbout = []
        let reg = new RegExp(e, 'ig')
        if(e){
            ticketQuestionsTree.forEach((q) => {
                let s = q.children.filter((qq)=>{
                    return reg.test(qq.question);
                })
                searchAbout = searchAbout.concat(s)
            })

            // 搜索请求
            setDefaultShow(false)
            setSearchShow(true)
            setDetailShow(false)
            setSearchValue(e)
            setResultList(searchAbout)
        }else {
            // console.log('no e')
        }
    }

    const showDetail = (e) => {
        lastSearchId.current = 0
        setSearchValue(0)
        setTimeout(() => {
            history.push({pathname:`/user/support/question`,state:{id:e.id, parentId:e.parentId}})
        })
    }

     // 去掉头部 将链接改成相对链接
     const removeHeader = (text) => {
        if(!text)return
        let before = text.split("<header>")[0];
        let after = text.split("</header>")[1];
        let noHeader = before + after;
        if(window.isShowApp == "true"){
            // 1. <a href="https://www.chicme.com/... 替换成 <a href="/...或者 <a href="wanna/...
            noHeader = noHeader.replace(/(<a href="https:\/\/www.chicme.com)/g, ()=>{return `<a href="chic-me://chic.me/web?href=https://${window.location.host? window.location.host: 'www.chicme.com'}`});
        } else {
            // 1. <a href="https://www.chicme.com/... 替换成 <a href="/...或者 <a href="wanna/...
            noHeader = noHeader.replace(/(<a href="https:\/\/www.chicme.com)/g, ()=>{return `<a href="${(window.ctx || '')}`});
        }
        // 2. >https://www.chicme.com/fs/shipping-policy-pc 替换成 shipping-policy
        noHeader = noHeader.replace(/(>https:\/\/www.chicme.com\/fs\/shipping-policy-pc)/g, ()=>{return '>shipping-policy'});
        // 3. >https://www.chicme.com/fs/shipping-policy-pc 替换成 shipping-policy
        noHeader = noHeader.replace(/(>https:\/\/www.chicme.com\/fs\/wholesale-program-pc)/, ()=>{return '>wholesale-program'});
        // 4. chicme、Chicme、chic me、Chic me 替换为 window.floderName
        noHeader = noHeader.replace(/(chicme|Chicme|Chic me|chic me|Chic Me|chic Me|ChicMe|chicMe)/g, ()=>{return window.floderName? window.floderName: 'Chicme'})
        return noHeader;
    }

    const highLightSearch = (title) => {
        let reg = new RegExp(''+searchValue+'', "ig");
        return title?.replace(reg, (e)=>{return '<strong>'+e+"</strong>"})
    }

    const toContact = () => {
        if(!customer?.id){
            if(isApp){
                window.location.href = "chic-me://chic.me/loginRoot"
            } else {
                window.location.href = `/i/login?redirectUrl=${encodeURIComponent('/support/contact-us')}`
            }
        } else {
            history.push(`/user/support/contact-us`)
            // window.location.href = `${BASE_ME}/support/contact-us`
        }
    }

    const clickItem = (e) => {
        setSearchValue(0)
        setTimeout(()=>{
            history.push({pathname:`/user/support/question`,state:{id:e.id, parentId: e?.parentId}})
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
             })
        })
    }

    return (
        <div className={classes.QuestionSearch}>
            <Header centerSlot={Intl.formatMessage({ id: "faq", defaultMessage: "FAQ" })}/>

            <div className={classes.SearchBarBox}>
                <SearchBar intl={Intl} search={e => search(e)} questions={ticketQuestionsTree} value={searchValue} stopSearch={stopSearch} history={history}/>
            </div>

            {
                searchShow ?
                <React.Fragment>
                    <SearchResult intl={Intl} resultList={resultList} searchValue={searchValue}/>
                    <SearchResultList intl={Intl} resultList={resultList} showDetail={showDetail} highLightSearch={highLightSearch} removeHeader={removeHeader}/>
                    {
                        resultList?.length == 0 &&
                        <SearchNoResult intl={Intl} toContact={toContact}/>
                    }
                </React.Fragment>:
                <React.Fragment></React.Fragment>
            }

            {
                detailShow ?
                <React.Fragment>
                    <QuestionDetail intl={Intl} toContact={toContact} removeHeader={removeHeader} likeQuestion={likeQuestion} setLikeQuestion={setLikeQuestion} secondary={secondary} richText={richText}/>
                    <RelatedBox intl={Intl} parent={parent} secondary={secondary} clickItem={clickItem}/>
                </React.Fragment>:
                <React.Fragment></React.Fragment>
            }

            
        </div>
    )
}

FaqSearch.fetchData = async (store, params, search, headers) => {
    const getQuestions = store.dispatch(action_fetch_ticket_questions_tree(headers))
    return await Promise.all([ getQuestions])
}

export default FaqSearch